import React, { Fragment } from 'react';
import PageFolderLink from '@frontastic/catwalk/js/app/pageFolderLink';
import clsx from 'clsx';
import { getHexColor } from '@srcDS/utils/helpers';
import { useMenuContext } from '@srcDS/provider/menu/MenuContext';
import styles from './DesktopMenu.module.scss';
import { Link } from '@srcDS/components/atoms/link/Link';

const Category = ({ isInvertedClass, category, insertConditionLevel }) => {
  const { activeLevel1, setActiveLevel1, getMenuItemData, setDefaultLevelNames } = useMenuContext();
  const { level, isVisibleInCurrentLocale, navItemColor, isVisibleInMenu } = getMenuItemData(category);

  if (!isVisibleInCurrentLocale || !isVisibleInMenu) {
    return null;
  }

  const linkColor = getHexColor(navItemColor) ?? '';
  const isActiveMenuItem = category.name === activeLevel1?.name;

  const handleMouseOver = () => {
    setActiveLevel1(category);
    setDefaultLevelNames(category);
  };

  if (category.tree === null) {
    return (
      <li
        key={category.name}
        data-testid="category-inner"
        className={clsx(styles.categoryName, isInvertedClass)}
        onMouseEnter={handleMouseOver}
      >
        <Link link={category} style={{ color: linkColor }}>
          {category.name}
        </Link>
      </li>
    );
  }

  if (insertConditionLevel && level !== insertConditionLevel) return null;
  return (
    <li
      key={category.name}
      data-testid="category-inner"
      className={clsx(styles.categoryName, isInvertedClass, {
        [styles.activeMenuItem]: isActiveMenuItem,
      })}
      onMouseEnter={handleMouseOver}
    >
      {!category.depth && category.tree ? (
          <Link link={category} style={{ color: linkColor }}>
            {category.name}
          </Link>
      ) : (
        <PageFolderLink
          key={category.pageFolderId}
          pageFolder={category}
          style={{ color: linkColor }}
          itemProp="url"
          aria-label={category.name}
        >
          <span itemProp="name">{category.name}</span>
        </PageFolderLink>
      )}
    </li>
  );
};

const DesktopMenu = ({ categories = [], isInvertedClass }) => {
  return (
    <nav itemScope="itemscope" itemType="http://www.schema.org/SiteNavigationElement" className={styles.desktopMenu}>
      {categories.map((category) => (
        <Fragment key={category.name}>
          <Category isInvertedClass={isInvertedClass} category={category} insertConditionLevel={1} />
        </Fragment>
      ))}
    </nav>
  );
};

export default DesktopMenu;
